//This feature is used to manage jobsites. It allows users to retrieve and toggle the status of jobsites. 
//It is for users of type business.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import foremanActionsService from "./foremanActionsService";

const initialState = {
    isError: null,
    isSuccess: null,
    isLoading: null,
    message: null,
}

//send invitation to a new worker to join the organization
export const sendInvite = createAsyncThunk('foremanAction/inviteWorker', 
    async (inviteeData, thunkAPI) => {
        //InviteeData contains the phone number , the name lastName of the worker to be invited, current jobsite id, and the worker role
        try {
            const token = thunkAPI.getState().auth.user.token;
            const response = await foremanActionsService.sendInvitation(token, inviteeData);

            return response;
        } catch (error) {
            const message = 
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);








export const sendInviteSlice = createSlice({
    name:'sendInvite',
    initialState,
    reducers:{
        reset: (state) => initialState,
        
      
    },
    extraReducers: (builder) =>{
        builder 
        // SEND INVITATION
        .addCase(sendInvite.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(sendInvite.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.isError = false;
            state.message = action.payload.message || 'Invitation sent successfully';
        })
        .addCase(sendInvite.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.isSuccess = false;
            state.message = action.payload.message || 'Failed to send invitation';
        });

}})
export const { reset } = sendInviteSlice.actions;
export default sendInviteSlice.reducer